<template>
  <div class="row dashboard-cards">
    <div class="col-xl-6 col-md-6">
      <stats-card>
        <div slot="header" class="icon-warning">
          <i class="fa-solid fa-headset"></i>
        </div>
        <div slot="content" class="card-content">
          <p v-capitalize>{{$t('ÇAĞRI_MƏRKƏZİ')}}</p>
          <span class="font-medium">{{ item.newAccidentCount }} {{$t('daxil_edilən_müraciətlər')}}</span>
          <br />
          <span class="font-primary"><i class="fa-solid fa-moon" title="gecə"></i>
            {{ item.nightAccidentCount }}
          </span>
          <span class="font-primary"><i class="fa-solid fa-sun" title="gündüz"></i>
            {{ item.dayAccidentCount }}
          </span>
        </div>
        <template slot="footer" class="card-footer">
          <i class="fa-solid fa-calendar-days"></i> {{ item.today }}
        </template>
      </stats-card>
    </div>

    <div class="col-xl-6 col-md-6">
      <stats-card>
        <div slot="header" class="icon-primary">
          <i class="fa-solid fa-person-military-pointing"></i>
        </div>
        <div slot="content" class="card-content">
          <p v-capitalize>{{$t('QƏZA_KOMİSSARI')}}</p>
          <span class="font-medium">{{ item.totalCommAccidentCount }} {{$t('iş_icraatda')}}</span>
          <br />
          <span class="font-primary"><i class="fa-solid fa-file" title="yeni"></i>
            {{ item.dayCommAccidentCount }}
          </span>
        </div>
        <template slot="footer" class="card-footer">
          <i class="fa-solid fa-calendar-days"></i> {{ item.today }}
        </template>
      </stats-card>
    </div>

    <div class="col-xl-6 col-md-6">
      <stats-card>
        <div slot="header" class="icon-success">
          <i class="fas fa-people-carry"></i>
        </div>
        <div slot="content" class="card-content">
          <p v-capitalize>{{$t('MÜŞTƏRİ_XİDMƏTLƏRİ')}}</p>
          <span class="font-medium">{{ item.totalClientAccidentCount }} {{$t('iş_icraatda')}}</span>
          <br />
          <span class="font-primary"><i class="fa-solid fa-file" title="yeni"></i>
            {{ item.dayClientAccidentCount }}
          </span>
        </div>
        <template slot="footer" class="card-footer">
          <i class="fa-solid fa-calendar-days"></i> {{ item.today }}
        </template>
      </stats-card>
    </div>

    <div class="col-xl-6 col-md-6">
      <stats-card>
        <div slot="header" class="icon-dark">
          <i class="fa-solid fa-wrench"></i>
        </div>
        <div slot="content" class="card-content">
          <p v-capitalize>{{$t('Qiymətləndirmə')}}</p>
          <span class="font-medium">{{ item.totalTechExpertAccidentCount }} {{$t('iş_icraatda')}}</span>
          <br />
          <span class="font-primary"><i class="fa-solid fa-file" title="yeni"></i>
            {{ item.dayTechExpertAccidentCount }}
          </span>
        </div>
        <template slot="footer" class="card-footer">
          <i class="fa-solid fa-calendar-days"></i> {{ item.today }}
        </template>
      </stats-card>
    </div>

    <div class="col-xl-6 col-md-6">
      <card>
        <p class="chart-title">{{$t('Gündəlik_hadisə_sayı')}}</p>
        <hr>
        <v-frappe-chart 
          v-if="accidentDays.length > 0"
          type="line" 
          :labels="accidentDaysLabels" 
          :data="[{
            values: accidentDaysCounts,
            chartType: 'line'
          }]" 
          :lineOptions="{
            regionFill: 1,
            dotSize: 6,
            heatline: true,
            hideLine: false,
            hideDots: false,
          }" 
          :colors="['green']" 
        />
        <template slot="footer" class="card-footer">
          <i class="fa-solid fa-calendar-days"></i> {{ item.today }}
        </template>
      </card>
    </div>

    <div class="col-xl-6 col-md-6">
      <card>
        <p class="chart-title">{{$t('Tapşırıqlarım')}}</p>
        <hr>
        <tasks :statuses="statuses" />
      </card>
    </div>
  </div>
</template>
<script>
  import { StatsCard, Card, Checkbox, Tasks } from "src/components/index";
  import { GetMainPageStat, GetAccidentsStatusByRole, GetAccidentLastDaysCount } from "../services/stats";
  import { DateToString } from "../services/helper";

  export default {
    components: {
      StatsCard,
      Tasks,
    },
    data() {
      return {
        uid: this.$store.state.user.id,
        roles: this.$store.state.user.roles.join(','), // Convert array to comma-separated string
        item: {},
        statuses: [],
        accidentDays: [],
        chartData: {
          labels: ['07', '08', '09', '10', '11'],
          datasets: [{
            label: 'AAPL',
            data: [22.2, 34.9, 42.28, 51.93, 62.21],
            borderColor: '#4CAF50',
            backgroundColor: 'rgba(76, 175, 80, 0.1)'
          }]
        },
        chartOptions: {
          scales: {
            y: {
              ticks: {
                callback: value => '$' + value
              }
            }
          }
        }

      };
    },
    methods: {
      getData() {
        GetMainPageStat().then((response) => {
          if (response.data) {
            this.item = response.data;
            this.item.today = this.formatDate(new Date());
          } else {
          }
        });
      },
      getAccidentsStatusByRole() {
        GetAccidentsStatusByRole(this.uid, this.roles).then((response) => {
          this.loading = false;
          if (response.data) {
            this.statuses = response.data;
          }
        });
      },
      getAccidentLastDaysCount() {
        GetAccidentLastDaysCount().then((response) => {
          if (response.data) {
            this.accidentDays = response.data;
          } else {
          }
        });
      },
      formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
      }

    },
computed: {
  accidentDaysLabels() {
    return this.accidentDays?.map(day => day?.dayMonth) || [];
  },
  accidentDaysCounts() {
    return this.accidentDays?.map(day => day?.count) || [];
  }
},
    mounted() {
      this.getData();
      this.getAccidentLastDaysCount();
      this.getAccidentsStatusByRole();
    },
  };
</script>
<style scoped>
  .icon-primary {
    color: #3445db;
  }

  .icon-success {
    color: #4fb178;
  }

  .icon-warning {
    color: #f39c12;
  }

  .icon-dark {
    color: #61778f;
  }
  .card .card-footer {
    padding: 0 15px 10px 15px;
    background-color: #a9a9a9 !important; /* or whatever color you prefer */
    line-height: 30px;
    border-top: none !important;
    font-size: var(--font-large);
}

</style>